import React from 'react';
import { Col, Row } from 'antd';

import MyPage from 'src/pages/MyPage';
import { HalfWrapper } from 'src/components/common/Styles';

function StudyInfo() {
  return (
    <MyPage>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <HalfWrapper>과목 리스트</HalfWrapper>
        </Col>
        <Col span={12}>
          <HalfWrapper>교재 리스트</HalfWrapper>
        </Col>
      </Row>
    </MyPage>
  );
}

export default StudyInfo;
